export const headers = [
  { content: "Member" },
  { content: "User type", isSorting: true },
  { content: "Permissions", isSorting: true },
  { content: "Admin Console" },
  { content: "Manage Suggestions" },
  { content: "Region", isSorting: true },
  { content: "Last Active", isSorting: true },
  { content: "" }
];
